import type { PropsWithChildren, FC } from 'react';

import { circleTextStyle, indexCircleRecipe } from './IndexCircle.css';
import { getClassNames } from '../../util/css';
import { RecipeVariants } from '../../vanilla-extract.css';
import { Text } from '../Text/Text';

const sparkyClassName = 'sparky-index-circle';

type IndexCircleVariants = RecipeVariants<typeof indexCircleRecipe>;

export const IndexCircle: FC<PropsWithChildren & IndexCircleVariants> = ({ children, ...variantProps }) => {
  const { emphasis = 'high', size = 'XS' } = variantProps;
  const classNames = getClassNames(sparkyClassName, indexCircleRecipe({ emphasis, size }));

  return (
    <div aria-hidden="true" className={classNames}>
      <Text align={'center'} weight={'bold'} className={circleTextStyle}>
        {children}
      </Text>
    </div>
  );
};

IndexCircle.toString = () => `.${sparkyClassName}`;
IndexCircle.displayName = 'IndexCircle';
